<template>
  <div class="table-content">
    <el-table :data="tableData" style="width: 100%" max-height="680" border>
      <el-table-column prop="name" label="用户名" width="220">
        <template v-slot="scope">
          <span class="link" @click="toLink(scope.row)">
            {{ scope.row.name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述">
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      tableData: []
    }
  },
  methods: {
    toLink(item) {
      console.log(item);
      this.getLink(item.objId)
    },
    getData() {
      const { id } = this.$route.query;
      axios.get('/pmdm/admin/user/getUserByPriv/?privId=' + id).then(res => {
        this.tableData = res.data.object.map(i => {
          const { id, classId, subClassId, displayUserName: title } = i
          const objId = { id, classId, subClassId, title };
          return {
            description: i.title,
            name: i.displayUserName,
            objId
          }
        })
      })
    }
  },
  created() {
    this.getData()
  },
}
</script>

<style scoped>
.table-content {
  padding: 15px;
  overflow: auto;
}

.link {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: #409EFF;
    border-bottom: 1px solid #409EFF;
  }
}
</style>